import ErrorHandlingFrom from "../../components/formValidation/ErrorHandlingFrom";
import React, {useEffect, useState} from "react";
import Stack from "@mui/material/Stack";
import CustomDatePicker from "../../components/formValidation/CustomDatePicker";
import {validateNumber, validateRequired} from "../../components/formValidation/validators";
import CustomTextField from "../../components/formValidation/CustomTextField";
import {FormControl, InputLabel, MenuItem} from "@mui/material";
import CustomSelect from "../../components/formValidation/CustomSelect";
import useCallDataApi from "../../hooks/data";
import Loading from "../../components/Loading";

const TxStockData = ({reference, obj}) => {
    const [transmitters, setTransmitters] = useState([])
    const [loading, setLoading] = useState(false)
    const {getData} = useCallDataApi('transmitters')
    useEffect(() => {
        setLoading(true)
        getData().then(r => setTransmitters(r)).finally(() => setLoading(false))
    }, [])

    const [data, setData] = useState({
        modification_date: obj?.modification_date || new Date(),
        how_many: obj?.how_many || 1,
        type: obj?.type || null,
    })
    const [errors, setErrors] = useState({
        modification_date: false,
        how_many: false,
        type: false,
    })
    const validators = {
        modification_date: [validateRequired],
        how_many: [validateRequired, validateNumber],
        type: [validateRequired],
    }
    return <ErrorHandlingFrom data={data} setData={setData} errors={errors} setErrors={setErrors} reference={reference} validators={validators}>
        <Stack spacing={2} marginTop={2}>
            <CustomDatePicker
                label="Készletváltozás dátuma"
                inputFormat="yyyy-MM-dd"
                mask="____-__-__"
                name="modification_date"
                data={data}
                setData={setData}
                errors={errors}
                setErrors={setErrors}
                validators={validators}
            />
            <CustomTextField
                label="Mennyiség"
                name="how_many"
                data={data}
                setData={setData}
                errors={errors}
                setErrors={setErrors}
                validators={validators}
            />
            <FormControl sx={{width: '100%'}}>
                <InputLabel id="receiver-type-select">Adó típusa</InputLabel>
                <CustomSelect
                    labelId="receiver-type-select"
                    label="Adó típusa"
                    name="type"
                    data={data}
                    setData={setData}
                    errors={errors}
                    setErrors={setErrors}
                    validators={validators}
                >
                    <MenuItem value={null}>-</MenuItem>
                    {transmitters.map(r => (
                        <MenuItem key={r.id} value={r.id}>{r.name}</MenuItem>
                    ))}
                </CustomSelect>
            </FormControl>
        </Stack>

        <Loading isLoading={loading}/>
    </ErrorHandlingFrom>
}

export default TxStockData